var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3631_18331)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.901 21.8537H19.0825C19.6238 21.8537 20.0726 21.4003 20.0726 20.8537C20.0726 20.307 19.6238 19.867 19.0825 19.867H11.901C11.3597 19.867 10.9109 20.307 10.9109 20.8537C10.9109 21.4003 11.3597 21.8537 11.901 21.8537ZM16.363 13.2003H11.901C11.3597 13.2003 10.9109 13.6537 10.9109 14.2003C10.9109 14.747 11.3597 15.187 11.901 15.187H16.363C16.9043 15.187 17.3531 14.747 17.3531 14.2003C17.3531 13.6537 16.9043 13.2003 16.363 13.2003ZM25.7841 12.0345C26.0944 12.0309 26.4323 12.027 26.7393 12.027C27.0693 12.027 27.3333 12.2937 27.3333 12.627V23.347C27.3333 26.6537 24.6799 29.3337 21.4059 29.3337H10.8977C7.46535 29.3337 4.66667 26.5203 4.66667 23.0537V8.68033C4.66667 5.37366 7.33334 2.66699 10.6205 2.66699H17.67C18.0132 2.66699 18.2772 2.94699 18.2772 3.28033V7.57366C18.2772 10.0137 20.2706 12.0137 22.6865 12.027C23.2508 12.027 23.7482 12.0312 24.1836 12.0349C24.5223 12.0378 24.8234 12.0403 25.0891 12.0403C25.277 12.0403 25.5206 12.0375 25.7841 12.0345ZM26.1481 10.0883C25.063 10.0923 23.7838 10.0883 22.8636 10.079C21.4036 10.079 20.2009 8.86433 20.2009 7.38966V3.87499C20.2009 3.30033 20.8914 3.01499 21.2861 3.42966C22.0012 4.18067 22.9842 5.21328 23.9624 6.24089C24.9363 7.2639 25.9055 8.28197 26.6009 9.01232C26.9864 9.41633 26.7039 10.087 26.1481 10.0883Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3631_18331",
    x: -3,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3631_18331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3631_18331",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.3340ad16458bbab667d6723e9b89e6a4.svg";
export { ForwardRef as ReactComponent };